/*

  Should be used only in reducers for initialState (for DEV)

 */

let urlParams: Partial<URLSearchParams> = {
  get: (name: string) => null,
}

if (typeof window !== 'function' && window.URLSearchParams) {
  urlParams = new URLSearchParams(window.location.search)
}

const getQueryValue = (key: string, isJSON: boolean): string | object | null => {
  if (isJSON) {
    try {
      return JSON.parse(urlParams.get(key)) || {}
    }
    catch (err) {
      return {}
    }
  }

  return urlParams.get(key)
}


export default getQueryValue
